export const initialState = {
  "tokenInfo": {
    "0x6CaF698cA73b1a5a27a44A6441545E291D955e90": {
      "btoken": "0x6CaF698cA73b1a5a27a44A6441545E291D955e90",
      "ctoken": "0x6C8c6b02E7b2BE14d4fA6022Dfd6d75921D90E4E",
      "ctokenDecimals": "8",
      "underlying": "0x0D8775F648430679A709E98d2b0Cb6250d2887EF",
      "underlyingDecimals": "18",
      "ctokenExchangeRate": "205356338394528844357977016",
      "underlyingPrice": "487315000000000000",
      "borrowRate": "0",
      "supplyRate": "0",
      "listed": true,
      "collateralFactor": "600000000000000000",
      "bTotalSupply": "509708143160646831"
    },
    "0x66d392FAAEFE95DcaA30625E8978C14BEA1721a7": {
      "btoken": "0x66d392FAAEFE95DcaA30625E8978C14BEA1721a7",
      "ctoken": "0x5d3a536E4D6DbD6114cc1Ead35777bAB948E3643",
      "ctokenDecimals": "8",
      "underlying": "0x6B175474E89094C44Da98b954EedeAC495271d0F",
      "underlyingDecimals": "18",
      "ctokenExchangeRate": "211494757405529119673192799",
      "underlyingPrice": "1001253000000000000",
      "borrowRate": "0",
      "supplyRate": "0",
      "listed": true,
      "collateralFactor": "750000000000000000",
      "bTotalSupply": "10443277367625522801"
    },
    "0xAE62A925924850a3f02A125477c1E2418f4085fF": {
      "btoken": "0xAE62A925924850a3f02A125477c1E2418f4085fF",
      "ctoken": "0x4Ddc2D193948926D02f9B1fE9e1daa0718270ED5",
      "ctokenDecimals": "8",
      "underlying": "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE",
      "underlyingDecimals": "18",
      "ctokenExchangeRate": "200353184431444902937931259",
      "underlyingPrice": "1627430000000000000000",
      "borrowRate": "0",
      "supplyRate": "0",
      "listed": true,
      "collateralFactor": "750000000000000000",
      "bTotalSupply": "6164394654613570"
    },
    "0x0000000000000000000000000000000000000000": {
      "btoken": "0x0000000000000000000000000000000000000000",
      "ctoken": "0xF5DCe57282A584D2746FaF1593d3121Fcac444dC",
      "ctokenDecimals": "8",
      "underlying": "0x89d24A6b4CcB1B6fAA2625fE562bDD9a23260359",
      "underlyingDecimals": "18",
      "ctokenExchangeRate": "214497546666952197312199338",
      "underlyingPrice": "8600967000000000000",
      "borrowRate": "0",
      "supplyRate": "0",
      "listed": true,
      "collateralFactor": "0",
      "bTotalSupply": "0"
    },
    "0x459EF67e0668a85CBf073073Cf45fb7e01c551a6": {
      "btoken": "0x459EF67e0668a85CBf073073Cf45fb7e01c551a6",
      "ctoken": "0x39AA39c021dfbaE8faC545936693aC917d5E7563",
      "ctokenDecimals": "8",
      "underlying": "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      "underlyingDecimals": "6",
      "ctokenExchangeRate": "216777458087733",
      "underlyingPrice": "1000000000000000000000000000000",
      "borrowRate": "0",
      "supplyRate": "0",
      "listed": true,
      "collateralFactor": "750000000000000000",
      "bTotalSupply": "8078464093589391856"
    },
    "0xB0e9443f9dBC1E39A550C9eBBA2bff38E81543D9": {
      "btoken": "0xB0e9443f9dBC1E39A550C9eBBA2bff38E81543D9",
      "ctoken": "0xf650C3d88D12dB855b8bf7D11Be6C55A4e07dCC9",
      "ctokenDecimals": "8",
      "underlying": "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      "underlyingDecimals": "6",
      "ctokenExchangeRate": "208540802065944",
      "underlyingPrice": "1000000000000000000000000000000",
      "borrowRate": "0",
      "supplyRate": "0",
      "listed": true,
      "collateralFactor": "0",
      "bTotalSupply": "1595768307930984815"
    },
    "0xAAb7A87b6aec217bc18fE2600C53134c05AB8208": {
      "btoken": "0xAAb7A87b6aec217bc18fE2600C53134c05AB8208",
      "ctoken": "0xC11b1268C1A384e55C48c2391d8d480264A3A7F4",
      "ctokenDecimals": "8",
      "underlying": "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      "underlyingDecimals": "8",
      "ctokenExchangeRate": "20201150702490738",
      "underlyingPrice": "497134500000000000000000000000000",
      "borrowRate": "0",
      "supplyRate": "0",
      "listed": true,
      "collateralFactor": "750000000000000000",
      "bTotalSupply": "196263349115660"
    },
    "0x4E55193e835980b0C0Ac4a0b4E7cDfbaF041e4A7": {
      "btoken": "0x4E55193e835980b0C0Ac4a0b4E7cDfbaF041e4A7",
      "ctoken": "0xB3319f5D18Bc0D84dD1b4825Dcde5d5f7266d407",
      "ctokenDecimals": "8",
      "underlying": "0xE41d2489571d322189246DaFA5ebDe1F4699F498",
      "underlyingDecimals": "18",
      "ctokenExchangeRate": "204255280074451121593865711",
      "underlyingPrice": "1444863000000000000",
      "borrowRate": "0",
      "supplyRate": "0",
      "listed": true,
      "collateralFactor": "600000000000000000",
      "bTotalSupply": "539861415438681457"
    },
    "0x2AACA31206cD011AcDE0d26a217690AfB7f41530": {
      "btoken": "0x2AACA31206cD011AcDE0d26a217690AfB7f41530",
      "ctoken": "0x35A18000230DA775CAc24873d00Ff85BccdeD550",
      "ctokenDecimals": "8",
      "underlying": "0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984",
      "underlyingDecimals": "18",
      "ctokenExchangeRate": "201689711082607411775350761",
      "underlyingPrice": "25257150000000000000",
      "borrowRate": "0",
      "supplyRate": "0",
      "listed": true,
      "collateralFactor": "600000000000000000",
      "bTotalSupply": "45457346170442977"
    },
    "0x261f1375e2b921b11DcE28171063A51E4fb2A813": {
      "btoken": "0x261f1375e2b921b11DcE28171063A51E4fb2A813",
      "ctoken": "0x70e36f6BF80a52b3B46b3aF8e106CC0ed743E8e4",
      "ctokenDecimals": "8",
      "underlying": "0xc00e94Cb662C3520282E6f5717214004A7f26888",
      "underlyingDecimals": "18",
      "ctokenExchangeRate": "202241357036972191139451230",
      "underlyingPrice": "431544999000000000000",
      "borrowRate": "0",
      "supplyRate": "0",
      "listed": true,
      "collateralFactor": "600000000000000000",
      "bTotalSupply": "1582916895991890"
    }
  },
  "cUser": {
    "0x6CaF698cA73b1a5a27a44A6441545E291D955e90": {
      "ctokenBalance": "0",
      "ctokenBorrowBalance": "0",
      "underlyingWalletBalance": "0",
      "underlyingAllowance": "0"
    },
    "0x66d392FAAEFE95DcaA30625E8978C14BEA1721a7": {
      "ctokenBalance": "0",
      "ctokenBorrowBalance": "0",
      "underlyingWalletBalance": "0",
      "underlyingAllowance": "0"
    },
    "0xAE62A925924850a3f02A125477c1E2418f4085fF": {
      "ctokenBalance": "0",
      "ctokenBorrowBalance": "0",
      "underlyingWalletBalance": "0",
      "underlyingAllowance": "115792089237316195423570985008687907853269984665640564039457584007913129639935"
    },
    "0x0000000000000000000000000000000000000000": {
      "ctokenBalance": "0",
      "ctokenBorrowBalance": "0",
      "underlyingWalletBalance": "0",
      "underlyingAllowance": "0"
    },
    "0x459EF67e0668a85CBf073073Cf45fb7e01c551a6": {
      "ctokenBalance": "0",
      "ctokenBorrowBalance": "0",
      "underlyingWalletBalance": "0",
      "underlyingAllowance": "0"
    },
    "0xB0e9443f9dBC1E39A550C9eBBA2bff38E81543D9": {
      "ctokenBalance": "0",
      "ctokenBorrowBalance": "0",
      "underlyingWalletBalance": "0",
      "underlyingAllowance": "0"
    },
    "0xAAb7A87b6aec217bc18fE2600C53134c05AB8208": {
      "ctokenBalance": "0",
      "ctokenBorrowBalance": "0",
      "underlyingWalletBalance": "0",
      "underlyingAllowance": "0"
    },
    "0x4E55193e835980b0C0Ac4a0b4E7cDfbaF041e4A7": {
      "ctokenBalance": "0",
      "ctokenBorrowBalance": "0",
      "underlyingWalletBalance": "0",
      "underlyingAllowance": "0"
    },
    "0x2AACA31206cD011AcDE0d26a217690AfB7f41530": {
      "ctokenBalance": "0",
      "ctokenBorrowBalance": "0",
      "underlyingWalletBalance": "0",
      "underlyingAllowance": "0"
    },
    "0x261f1375e2b921b11DcE28171063A51E4fb2A813": {
      "ctokenBalance": "0",
      "ctokenBorrowBalance": "0",
      "underlyingWalletBalance": "0",
      "underlyingAllowance": "0"
    }
  },
  "bUser": {
    "0x6CaF698cA73b1a5a27a44A6441545E291D955e90": {
      "ctokenBalance": "0",
      "ctokenBorrowBalance": "0",
      "underlyingWalletBalance": "0",
      "underlyingAllowance": "0"
    },
    "0x66d392FAAEFE95DcaA30625E8978C14BEA1721a7": {
      "ctokenBalance": "0",
      "ctokenBorrowBalance": "0",
      "underlyingWalletBalance": "0",
      "underlyingAllowance": "0"
    },
    "0xAE62A925924850a3f02A125477c1E2418f4085fF": {
      "ctokenBalance": "0",
      "ctokenBorrowBalance": "0",
      "underlyingWalletBalance": "0",
      "underlyingAllowance": "115792089237316195423570985008687907853269984665640564039457584007913129639935"
    },
    "0x0000000000000000000000000000000000000000": {
      "ctokenBalance": "0",
      "ctokenBorrowBalance": "0",
      "underlyingWalletBalance": "0",
      "underlyingAllowance": "0"
    },
    "0x459EF67e0668a85CBf073073Cf45fb7e01c551a6": {
      "ctokenBalance": "0",
      "ctokenBorrowBalance": "0",
      "underlyingWalletBalance": "0",
      "underlyingAllowance": "0"
    },
    "0xB0e9443f9dBC1E39A550C9eBBA2bff38E81543D9": {
      "ctokenBalance": "0",
      "ctokenBorrowBalance": "0",
      "underlyingWalletBalance": "0",
      "underlyingAllowance": "0"
    },
    "0xAAb7A87b6aec217bc18fE2600C53134c05AB8208": {
      "ctokenBalance": "0",
      "ctokenBorrowBalance": "0",
      "underlyingWalletBalance": "0",
      "underlyingAllowance": "0"
    },
    "0x4E55193e835980b0C0Ac4a0b4E7cDfbaF041e4A7": {
      "ctokenBalance": "0",
      "ctokenBorrowBalance": "0",
      "underlyingWalletBalance": "0",
      "underlyingAllowance": "0"
    },
    "0x2AACA31206cD011AcDE0d26a217690AfB7f41530": {
      "ctokenBalance": "0",
      "ctokenBorrowBalance": "0",
      "underlyingWalletBalance": "0",
      "underlyingAllowance": "0"
    },
    "0x261f1375e2b921b11DcE28171063A51E4fb2A813": {
      "ctokenBalance": "0",
      "ctokenBorrowBalance": "0",
      "underlyingWalletBalance": "0",
      "underlyingAllowance": "0"
    }
  },
  "importInfo": {
    "0x6CaF698cA73b1a5a27a44A6441545E291D955e90": {
      "avatar": "0xAc78c5AA67672eA8c2CdFf331beF19f88A39eb4D",
      "ctokenAllowance": "0",
      "availableEthBalance": "45931582793422743378443"
    },
    "0x66d392FAAEFE95DcaA30625E8978C14BEA1721a7": {
      "avatar": "0xAc78c5AA67672eA8c2CdFf331beF19f88A39eb4D",
      "ctokenAllowance": "0",
      "availableEthBalance": "45931582793422743378443"
    },
    "0xAE62A925924850a3f02A125477c1E2418f4085fF": {
      "avatar": "0xAc78c5AA67672eA8c2CdFf331beF19f88A39eb4D",
      "ctokenAllowance": "0",
      "availableEthBalance": "45931582793422743378443"
    },
    "0x0000000000000000000000000000000000000000": {
      "avatar": "0xAc78c5AA67672eA8c2CdFf331beF19f88A39eb4D",
      "ctokenAllowance": "0",
      "availableEthBalance": "45931582793422743378443"
    },
    "0x459EF67e0668a85CBf073073Cf45fb7e01c551a6": {
      "avatar": "0xAc78c5AA67672eA8c2CdFf331beF19f88A39eb4D",
      "ctokenAllowance": "0",
      "availableEthBalance": "45931582793422743378443"
    },
    "0xB0e9443f9dBC1E39A550C9eBBA2bff38E81543D9": {
      "avatar": "0xAc78c5AA67672eA8c2CdFf331beF19f88A39eb4D",
      "ctokenAllowance": "0",
      "availableEthBalance": "45931582793422743378443"
    },
    "0xAAb7A87b6aec217bc18fE2600C53134c05AB8208": {
      "avatar": "0xAc78c5AA67672eA8c2CdFf331beF19f88A39eb4D",
      "ctokenAllowance": "0",
      "availableEthBalance": "45931582793422743378443"
    },
    "0x4E55193e835980b0C0Ac4a0b4E7cDfbaF041e4A7": {
      "avatar": "0xAc78c5AA67672eA8c2CdFf331beF19f88A39eb4D",
      "ctokenAllowance": "0",
      "availableEthBalance": "45931582793422743378443"
    },
    "0x2AACA31206cD011AcDE0d26a217690AfB7f41530": {
      "avatar": "0xAc78c5AA67672eA8c2CdFf331beF19f88A39eb4D",
      "ctokenAllowance": "0",
      "availableEthBalance": "45931582793422743378443"
    },
    "0x261f1375e2b921b11DcE28171063A51E4fb2A813": {
      "avatar": "0xAc78c5AA67672eA8c2CdFf331beF19f88A39eb4D",
      "ctokenAllowance": "0",
      "availableEthBalance": "45931582793422743378443"
    }
  },
  "jarInfo": {
    "0x6CaF698cA73b1a5a27a44A6441545E291D955e90": {
      "ctokenBalance": "0"
    },
    "0x66d392FAAEFE95DcaA30625E8978C14BEA1721a7": {
      "ctokenBalance": "0"
    },
    "0xAE62A925924850a3f02A125477c1E2418f4085fF": {
      "ctokenBalance": "0"
    },
    "0x0000000000000000000000000000000000000000": {
      "ctokenBalance": "0"
    },
    "0x459EF67e0668a85CBf073073Cf45fb7e01c551a6": {
      "ctokenBalance": "0"
    },
    "0xB0e9443f9dBC1E39A550C9eBBA2bff38E81543D9": {
      "ctokenBalance": "0"
    },
    "0xAAb7A87b6aec217bc18fE2600C53134c05AB8208": {
      "ctokenBalance": "0"
    },
    "0x4E55193e835980b0C0Ac4a0b4E7cDfbaF041e4A7": {
      "ctokenBalance": "0"
    },
    "0x2AACA31206cD011AcDE0d26a217690AfB7f41530": {
      "ctokenBalance": "0"
    },
    "0x261f1375e2b921b11DcE28171063A51E4fb2A813": {
      "ctokenBalance": "0"
    }
  },
  "tvlInfo": {
    "0x6CaF698cA73b1a5a27a44A6441545E291D955e90": {
      "numAccounts": "0"
    },
    "0x66d392FAAEFE95DcaA30625E8978C14BEA1721a7": {
      "numAccounts": "0"
    },
    "0xAE62A925924850a3f02A125477c1E2418f4085fF": {
      "numAccounts": "0"
    },
    "0x0000000000000000000000000000000000000000": {
      "numAccounts": "0"
    },
    "0x459EF67e0668a85CBf073073Cf45fb7e01c551a6": {
      "numAccounts": "0"
    },
    "0xB0e9443f9dBC1E39A550C9eBBA2bff38E81543D9": {
      "numAccounts": "0"
    },
    "0xAAb7A87b6aec217bc18fE2600C53134c05AB8208": {
      "numAccounts": "0"
    },
    "0x4E55193e835980b0C0Ac4a0b4E7cDfbaF041e4A7": {
      "numAccounts": "0"
    },
    "0x2AACA31206cD011AcDE0d26a217690AfB7f41530": {
      "numAccounts": "0"
    },
    "0x261f1375e2b921b11DcE28171063A51E4fb2A813": {
      "numAccounts": "0"
    }
  },
  "compTokenInfo": {
    "0x6CaF698cA73b1a5a27a44A6441545E291D955e90": {
      "compBalance": "0",
      "comp": "0xc00e94Cb662C3520282E6f5717214004A7f26888"
    },
    "0x66d392FAAEFE95DcaA30625E8978C14BEA1721a7": {
      "compBalance": "0",
      "comp": "0xc00e94Cb662C3520282E6f5717214004A7f26888"
    },
    "0xAE62A925924850a3f02A125477c1E2418f4085fF": {
      "compBalance": "0",
      "comp": "0xc00e94Cb662C3520282E6f5717214004A7f26888"
    },
    "0x0000000000000000000000000000000000000000": {
      "compBalance": "0",
      "comp": "0xc00e94Cb662C3520282E6f5717214004A7f26888"
    },
    "0x459EF67e0668a85CBf073073Cf45fb7e01c551a6": {
      "compBalance": "0",
      "comp": "0xc00e94Cb662C3520282E6f5717214004A7f26888"
    },
    "0xB0e9443f9dBC1E39A550C9eBBA2bff38E81543D9": {
      "compBalance": "0",
      "comp": "0xc00e94Cb662C3520282E6f5717214004A7f26888"
    },
    "0xAAb7A87b6aec217bc18fE2600C53134c05AB8208": {
      "compBalance": "0",
      "comp": "0xc00e94Cb662C3520282E6f5717214004A7f26888"
    },
    "0x4E55193e835980b0C0Ac4a0b4E7cDfbaF041e4A7": {
      "compBalance": "0",
      "comp": "0xc00e94Cb662C3520282E6f5717214004A7f26888"
    },
    "0x2AACA31206cD011AcDE0d26a217690AfB7f41530": {
      "compBalance": "0",
      "comp": "0xc00e94Cb662C3520282E6f5717214004A7f26888"
    },
    "0x261f1375e2b921b11DcE28171063A51E4fb2A813": {
      "compBalance": "0",
      "comp": "0xc00e94Cb662C3520282E6f5717214004A7f26888"
    }
  },
  "scoreInfo": {
    "0x6CaF698cA73b1a5a27a44A6441545E291D955e90": {
      "userScore": "0",
      "userScoreProgressPerSec": "0",
      "totalScore": "0"
    },
    "0x66d392FAAEFE95DcaA30625E8978C14BEA1721a7": {
      "userScore": "0",
      "userScoreProgressPerSec": "0",
      "totalScore": "0"
    },
    "0xAE62A925924850a3f02A125477c1E2418f4085fF": {
      "userScore": "0",
      "userScoreProgressPerSec": "0",
      "totalScore": "0"
    },
    "0x0000000000000000000000000000000000000000": {
      "userScore": "0",
      "userScoreProgressPerSec": "0",
      "totalScore": "0"
    },
    "0x459EF67e0668a85CBf073073Cf45fb7e01c551a6": {
      "userScore": "0",
      "userScoreProgressPerSec": "0",
      "totalScore": "0"
    },
    "0xB0e9443f9dBC1E39A550C9eBBA2bff38E81543D9": {
      "userScore": "0",
      "userScoreProgressPerSec": "0",
      "totalScore": "0"
    },
    "0xAAb7A87b6aec217bc18fE2600C53134c05AB8208": {
      "userScore": "0",
      "userScoreProgressPerSec": "0",
      "totalScore": "0"
    },
    "0x4E55193e835980b0C0Ac4a0b4E7cDfbaF041e4A7": {
      "userScore": "0",
      "userScoreProgressPerSec": "0",
      "totalScore": "0"
    },
    "0x2AACA31206cD011AcDE0d26a217690AfB7f41530": {
      "userScore": "0",
      "userScoreProgressPerSec": "0",
      "totalScore": "0"
    },
    "0x261f1375e2b921b11DcE28171063A51E4fb2A813": {
      "userScore": "0",
      "userScoreProgressPerSec": "0",
      "totalScore": "0"
    }
  }
}